module.exports = __webpack_public_path__ + "img/59.e4d3514e.jpg";